import styled from 'styled-components';

export const OccurancePicker = styled.div`
  display: inline-block;
  position: relative;
`;
